/**
 * Legacy `/settings` page — composes six `<SettingsForm>` instances
 * so users arriving via the old link still see the full Greptile-parity
 * form on a single page. The newer sub-pages under `/code-review/*`
 * each compose just one section.
 */
import { useSearchParams } from 'react-router-dom';
import { SettingsForm } from '../components/SettingsForm.js';

export function SettingsPage() {
  const [searchParams] = useSearchParams();
  const installationId = Number(searchParams.get('installation_id') ?? 0);

  return (
    <main className="feluda-settings">
      <header className="feluda-settings-header">
        <h1 className="feluda-settings-title">Settings</h1>
        {installationId > 0 && (
          <span className="feluda-settings-subtitle">Installation #{installationId}</span>
        )}
      </header>

      <SettingsForm
        section="whenReview"
        title="When Feluda Reviews"
        subtitle="Configure which pull requests trigger an automatic review."
      />
      <SettingsForm
        section="summaries"
        title="PR Summaries"
        subtitle="Shape the body of Feluda's review comments."
      />
      <SettingsForm
        section="instructions"
        title="Custom Instructions"
        subtitle="Tune the prompts Feluda uses when reviewing."
      />
      <SettingsForm
        section="comments"
        title="Feluda Comments"
        subtitle="Calibrate how aggressively Feluda comments."
      />
      <SettingsForm
        section="filters"
        title="Filters"
        subtitle="Skip reviews that don't match these gates."
      />
      <SettingsForm
        section="autoApprove"
        title="Auto-approve"
        subtitle="Automatically merge PRs Feluda reviews as low-risk."
      />
      <SettingsForm
        section="agents"
        title="Default Coding Agents"
        subtitle="Pick which CLI agents Feluda may invoke, and which one is the active default."
      />
      <SettingsForm
        section="statusChecks"
        title="Status Checks"
        subtitle="Choose which CI status checks Feluda surfaces in the PR summary."
      />
    </main>
  );
}
